export default __webpack_public_path__ + "static/media/tapeTwoMobile.06f5c068.svg";